
class SceneBase{
  constructor(){
    this.bLoaded = false;
    this.sceneObjects = [];
    this.rayTargetObjects = [];
  }

  async loadModels(){
  }

  getSceneObjects(){
    return this.sceneObjects;
  }

  getRayTargetObjects(){
    return this.rayTargetObjects;
  }

  destroy(){
  }
}

export default SceneBase;
